import React from 'react';
import { AppRouter } from './router';

export const App: React.FC = () => {
  return (
    <div className={`full`}>
      <AppRouter />
    </div>
  );
};
